import React, { FC } from 'react'

import {
  Center,
  Stack,
  Switcher,
  Text,
  Cluster,
  Box,
  Grid,
} from '../common'
import { NextIcon } from '../common/icons/NextIcon'
import { Tabs } from '../components/Tabs'
import { css } from '@emotion/core'

export const EligibilityCriteria: FC = props => {
  return (
    <Center gutters="var(--s2)" maxWidth="var(--max-width)" style={{display:"block",position:"relative",width:"80%"}}>
      <Tabs
        centered={true}
        tabs={[
          // {
          //   title: "Features & Benefits",
          //   key: "features",
          //   element: <PointsGrid data={FEATURES} />,
          // },
          {
            title: 'Eligibility Criteria',
            key: 'eligibility',
            element: <Eligibility />,
          },
          {
            title: 'How to apply a loan',
            key: 'apply',
            element: <ApplyProcedure />,
          },
        ]}
      />
    </Center>
  )
}

const Eligibility: FC = props => {
  return (
    <Box>
      {/* <Center gutters="var(--s4)" maxWidth="var(--max-width)"> */}
      {/* <Stack ></Stack> */}
      <Stack space="var(--s1)">
        <Switcher threshold="var(--min-width)" space="var(--s2)" max={2}>
          <Stack style={{ flexGrow: 2 }} space="var(--s0)">
            <Stack
              space="var(--s-4)"
              style={{ paddingTop: 'var(--s2)', }}>
              <Text
                variant="h4"
                style={{
                  fontFamily: 'var(--body-font-family)',
                  whiteSpace: 'pre-line',
                  textAlign:'justify'

                }}
                color="light">
                Share your personal and work details with us to know your loan
                eligibility. You will be eligible if,
              </Text>

              <Stack space="var(--s0)">
                {ELIGIBILITY_CRITERIA.map(item => (
                  <Cluster space="var(--s0)" align="flex-start"  >
                    <NextIcon />
                        <Text
                          variant="h4"
                          style={{
                            fontFamily: 'var(--body-font-family)',
                            whiteSpace: 'pre-line',
                            display: 'inline-block',
                            width: '80%',
                            textAlign:'justify'
                          }}
                          color="light">
                          {item.title}
                      </Text>
                  </Cluster>
                ))}
              </Stack>
            </Stack>
          </Stack>
          <Box >
            {/* <Frame numerator={34} denominator={26} > */}
            <img
              width={350}
              height={400}
              src={
                'https://res.cloudinary.com/dhoiqmk4x/image/upload/v1631685031/Website/City/instant-personal-loan-app-ZinCash_kxt5um.png'
              }
              alt={'Instant personal loan app ZinCash'}
            />
            {/* </Frame> */}
          </Box>
        </Switcher>
        {/* </Center> */}
      </Stack>
    </Box>

  )
}

const ELIGIBILITY_CRITERIA = [
  {
    title: 'Your age is between 21 years and 60 years.',
  },
  {
    title: 'You are employed in a private, public or government sector and getting your salary in Bank Account.',
  },
  {
    title: 'You have 2 years of total work experience.',
  },
  {
    title:
      'You have completed minimum 6 months’ period with your current employer.',
  },
  {
    title: 'You are earning at least INR 15,000 per month.',
  },
]

const APPLY_PROCEDURE = [
  {
    title: 'Application at your convenience',
    content: [
      `ZinCash gives you the power to apply an instant
    persolan loan at convenience of your home and
    with some finger taps on your phone`,
    ],
  },
  {
    title: 'Round the clock acceptance 24x7',
    content: [
      `ZinCash is powered by Artificial Inteligence not
      only allows us to accept any loan application in
      real-time, it also allows us to process instantly.`,
    ],
  },
  {
    title: 'Verification and Sanction Process',
    content: [
      'No paperwork required to verify your documents or to sanction your loan amount. Enjoy quick and easy approach for a personal loan.',
    ],
  },
  {
    title: 'Quick Approval & Disbursal',
    content: [
      'After a quick verification, we’ll approve your loan and the amount will be disbursed in 2 days’ time.',
    ],
  },
]

const ApplyProcedure: FC = props => {
  return (

    <Box style={{ paddingTop: 'var(--s3)' }}>
      <Stack space="var(--s1)">
        <Switcher threshold="var(--min-width)" space="var(--s1)" max={2}>
          <Text
            variant="h4"
            color="light"
            style={{ fontFamily: 'var(--body-font-family)' ,textAlign:'justify'}}>
            You can apply for an Instant Personal Loan through ZinCash in a
            simple and hassle-free method. We are at your fingertips with
            ZinCash, our mobile app, you can download our app and get loans from
            INR 10,000 upto INR 2,00,000 lacs quickly.
          </Text>
        </Switcher>
        <PointsGrid data={APPLY_PROCEDURE} />
      </Stack>
    </Box>
  )
}

const PointsGrid: FC<{
  data: Array<{ title: string; content: string[] }>
}> = props => {
  return (
    <Grid gap="var(--s5)" min="300px">
      {props.data.map(item => (
        <Box>
          <Switcher max={2} threshold="0px" space="var(--s0)">
            <NextIcon />
            <Stack space="var(--s0)" style={{ flexGrow: 15 }}>
              <Text variant="h4">{item.title}</Text>
              <ul
                style={{ listStyleType: 'none' }}
                css={css`
                  p {
                    margin-bottom: var(--s-2);
                  }
                `}>
                {item.content.map(str => (
                  <li>
                    <Text
                      variant="h4"
                      color="light"
                      style={{ fontFamily: 'var(--body-font-family)',textAlign:'justify' }}>
                      {str}
                    </Text>
                  </li>
                ))}
              </ul>
            </Stack>
          </Switcher>
        </Box>
      ))}
    </Grid>
  )
}
